import type { Echeance } from './types.js';

export type TonDelai = 'urgent' | 'proche' | 'normal' | 'termine';

const JOUR_MS = 86_400_000;
const enJours = (date: string): number => {
  const [a, m, j] = date.split('-').map(Number) as [number, number, number];
  return Math.round(Date.UTC(a, m - 1, j) / JOUR_MS);
};

/** Jours calendaires entre aujourd’hui et l’échéance (négatif si dépassée). */
export const joursRestants = (echeance: string, aujourdhui: string): number => enJours(echeance) - enJours(aujourdhui);

/** Jours écoulés depuis une date. */
export const joursDepuis = (date: string, aujourdhui: string): number => enJours(aujourdhui) - enJours(date);

const pluriel = (n: number, mot: string): string => `${n} ${mot}${n > 1 ? 's' : ''}`;

/** Formule le délai d’une échéance ; l’état « proche » est calculé par le serveur (seuils versionnés), jamais ici. */
export function presenterDelai(echeance: Echeance, aujourdhui: string): { texte: string; ton: TonDelai } {
  if (echeance.status === 'faite') return { texte: 'faite', ton: 'termine' };
  const jours = joursRestants(echeance.dueAt, aujourdhui);
  if (jours < 0) return { texte: `dépassée de ${pluriel(-jours, 'jour')}`, ton: 'urgent' };
  const ton: TonDelai = echeance.status === 'depassee' ? 'urgent' : echeance.status === 'proche' ? 'proche' : 'normal';
  return { texte: jours === 0 ? 'aujourd’hui' : `dans ${pluriel(jours, 'jour')}`, ton };
}
